import { type LucideProps } from 'lucide-react'

export default function Tinybird(props: LucideProps) {
  return (
    <svg viewBox='0 0 66 66' fill='none' {...props}>
      <path
        d='M63.5312 9.53879C64.1386 9.30879 64.529 8.714 64.4983 8.06524C64.4677 7.41648 64.023 6.86113 63.3966 6.68939L44.6646 1.55339C43.9509 1.35769 43.2011 1.71182 42.8988 2.38738L36.8186 15.9766L2.505 27.972C1.90501 28.1818 1.50235 28.7469 1.50001 29.3825C1.49767 30.0181 1.89617 30.5861 2.4946 30.8003L25.9569 39.1964L16.4791 62.4335C16.2292 63.0463 16.4103 63.7504 16.9249 64.1665C17.4396 64.5825 18.1661 64.6122 18.7129 64.2394L45.9289 45.6874C46.2472 45.4704 46.4699 45.1392 46.5507 44.7624L53.2692 13.4247L63.5312 9.53879Z'
        fill='currentColor'
        strokeWidth='3'
        strokeLinejoin='round'
      />
      <path
        opacity='0.6'
        d='M63.0002 8.136L44.2682 3L37.6802 17.724L63.0002 8.136ZM45.0842 44.448L27.9362 38.316L17.8682 63L45.0842 44.448Z'
        fill='currentColor'
      />
      <path
        d='M3 29.3896L45.084 44.4496L51.984 12.2656L3 29.3896Z'
        fill='currentColor'
      />
    </svg>
  )
}
